var React = require('react');

function CircleInline (props) {
    return React.createElement("svg",props,React.createElement("circle",{"cx":"13.5","cy":"13.5","r":"10","stroke":"currentColor","strokeWidth":"7"}));
}

CircleInline.defaultProps = {"width":"27","height":"27","viewBox":"0 0 27 27","fill":"none"};

module.exports = CircleInline;

CircleInline.default = CircleInline;
